import React from "react";
import { motion } from "framer-motion";
import styles from "../style/ServicesPage.module.css";
import SEO from "../components/SEO";
import { useGetServicesQuery } from "../redux/api";
import * as Icons from "react-icons/fa";

const staticServices = [
  {
    id: "001",
    title: "SEO Optimization",
    img: "/services/seo.jpeg",
    icon: "FaSearch",
  },
  {
    id: "002",
    title: "Website & App Development",
    img: "/services/website.jpeg",
    icon: "FaLaptopCode",
  },
  {
    id: "003",
    title: "Custom Software (CRM / ERP)",
    img: "/services/crm.jpeg",
    icon: "FaCogs",
  },
  {
    id: "004",
    title: "E-commerce Platform Management",
    img: "/services/amazon.jpeg",
    icon: "FaShoppingCart",
  },
  {
    id: "005",
    title: "Social Media Management",
    img: "/services/social.jpeg",
    icon: "FaBullhorn",
  },
  {
    id: "006",
    title: "Cyber Security Solutions",
    img: "/services/cyber.jpeg",
    icon: "FaShieldAlt",
  },
  {
    id: "007",
    title: "Performance Marketing",
    img: "/services/performance.jpeg",
    icon: "FaRocket",
  },
  {
    id: "008",
    title: "Content Creation",
    img: "/services/contentCreation.jpeg",
    icon: "FaBullhorn",
  },
];

const ServicesPage = () => {
  const { data: apiServices, isLoading } = useGetServicesQuery();
  const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.createchsquads.com";

  // Use API services if available and not empty, otherwise fallback to static services
  const servicesToRender = apiServices && apiServices.length > 0 
    ? apiServices 
    : staticServices;

  return (
    <div className={styles.servicesPage}>
      <SEO
        title="IT Services: SEO, Web Dev, ERP & CRM"
        description="Explore CreaTech Squads' full range of services: SEO optimization, website & app development, custom CRM/ERP software, e-commerce management, social media, cyber security & performance marketing."
        keywords="SEO services India, web development company, CRM software, ERP solutions, e-commerce management, social media marketing, cyber security, content creation"
        canonical="/services"
        breadcrumbs={[
          { name: "Home", item: "/" },
          { name: "Services", item: "/services" }
        ]}
        schemaData={{
          "@context": "https://schema.org",
          "@type": "ItemList",
          "itemListElement": servicesToRender.map((service, index) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": {
              "@type": "Service",
              "name": service.title,
              "provider": {
                "@type": "Organization",
                "name": "CreaTech Squads"
              },
              "image": service.image 
                ? `${API_BASE_URL}/${service.image.replace(/\\/g, "/")}` 
                : `https://createchsquads.com${service.img}`,
              "description": `Professional ${service.title} services by CreaTech Squads.`
            }
          }))
        }}
      />
      <motion.section
        className={styles.hero}
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <h1>Services</h1>
        <p>Home / Services</p>
      </motion.section>

      {/* SERVICES GRID */}
      <section className={styles.servicesSection}>
        {isLoading && apiServices === undefined ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "50px 0" }}>
            <div className="loader" style={{ width: "40px", height: "40px", border: "4px solid #f3f3f3", borderTop: "4px solid #60a626", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
          </div>
        ) : (
          <div className={styles.grid}>
            {servicesToRender.map((service, index) => {
              const IconComponent = Icons[service.icon] || Icons.FaLaptopCode;
              const imageUrl = service.image 
                ? `${API_BASE_URL}/${service.image.replace(/\\/g, "/")}` 
                : service.img;
              
              return (
                <motion.div
                  key={service._id || service.id}
                  className={styles.card}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <div className={styles.imageWrapper}>
                    <img src={imageUrl} alt={service.title} />
                  </div>

                  <div className={styles.cardContent}>
                    <div className={styles.titleRow}>
                      <div className={styles.icon}>
                        <IconComponent />
                      </div>
                      <h3>{service.title}</h3>
                    </div>
                    {service.description && (
                      <p className={styles.description}>{service.description}</p>
                    )}
                    {service.link && (
                      <a href={service.link} target="_blank" rel="noopener noreferrer" className={styles.learnMore}>
                        Learn More →
                      </a>
                    )}
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default ServicesPage;
